import { pathJoin } from 'src/reducers/routing/utils'

export const createCompanyEmailAccountDetailViewRoutesMap = (
  prefix: string
) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  rules: pathJoin(prefix)('rules').chain,
})
